<template>
  <div v-if="visible">
    <div class="modal-backdrop fade show" @click.self="close"></div>

    <div class="modal d-block" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <form @submit.prevent="saveProfile" class="modal-content" enctype="multipart/form-data" novalidate>
          <div class="modal-header">
            <h5 class="modal-title">Minha Conta</h5>
            <button type="button" class="close" @click="close"><span>&times;</span></button>
          </div>

          <div class="modal-body">
            <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
            <div v-if="successMessage" class="alert alert-success">{{ successMessage }}</div>

            <!-- Avatar -->
            <div class="text-center mb-4">
              <div class="position-relative d-inline-block">
                <img
                  :src="previewPhoto || form.photoUrl || '/imgs/default-profile.png'"
                  class="rounded-circle border shadow"
                  style="width: 120px; height: 120px; object-fit: cover"
                />
                <label
                  for="photo"
                  class="position-absolute top-0 end-0 translate-middle p-2 bg-white rounded-circle shadow-sm"
                  style="cursor: pointer"
                >
                  <i class="fas fa-pen"></i>
                </label>
                <input type="file" id="photo" class="d-none" @change="onPhotoChange" accept="image/*" />
              </div>
            </div>

            <!-- Informações do usuário -->
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Nome</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fas fa-user"></i></span>
                  </div>
                  <input v-model.trim="form.name" type="text" class="form-control" disabled />
                </div>
              </div>

              <div class="form-group col-md-6">
                <label>Email</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fas fa-envelope"></i></span>
                  </div>
                  <input v-model.trim="form.email" type="email" class="form-control" disabled />
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Login</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fas fa-user-lock"></i></span>
                  </div>
                  <input type="text" :value="form.login" class="form-control" disabled />
                </div>
              </div>

              <div class="form-group col-md-6">
                <label>Ramal</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fas fa-phone"></i></span>
                  </div>
                  <input type="text" :value="form.extension" class="form-control" disabled />
                </div>
              </div>
            </div>

            <!-- Fila/Grupo -->
            <div class="form-group">
              <multiselect-component
                :key="queueComponentKey"
                name="queue"
                id="queueProfile"
                icon="fas fa-users"
                title="Fila/Grupo"
                data-type="queueList"
                :required="false"
                :readonly="false"
                :disabled="false"
                :value="form.queue"
                @input="updateQueue"
              >
              </multiselect-component>
            </div>

            <!-- Senha -->
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Senha</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fas fa-key"></i></span>
                  </div>
                  <input
                    v-model="form.password"
                    type="password"
                    class="form-control"
                    :class="passwordValidationClass"
                    placeholder="Deixe em branco para manter a senha atual"
                  />
                </div>
              </div>

              <div class="form-group col-md-6">
                <label>Confirmar Senha</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fas fa-check"></i></span>
                  </div>
                  <input
                    v-model="form.passwordConfirm"
                    type="password"
                    class="form-control"
                    :class="passwordConfirmValidationClass"
                    placeholder="Confirme a senha"
                  />
                </div>
                <div
                  v-if="form.password && form.passwordConfirm && form.password !== form.passwordConfirm"
                  class="invalid-feedback d-block"
                >
                  As senhas não coincidem.
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="close" :disabled="loading">
              Cancelar
            </button>
            <button type="submit" class="btn btn-primary" :disabled="loading">
              <span v-if="loading">Salvando...</span>
              <span v-else>Salvar</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      visible: false,
      loading: false,
      errorMessage: "",
      successMessage: "",
      previewPhoto: null,
      queues: [],
      queueComponentKey: 0,
      form: {
        name: "",
        email: "",
        extension: "",
        queue: [],
        login: "",
        password: "",
        passwordConfirm: "",
        photoFile: null,
        photoUrl: "",
        emailSignature: "",
      },
    };
  },

  computed: {
    passwordValidationClass() {
      if (!this.form.password && !this.form.passwordConfirm) return "";
      return this.form.password === this.form.passwordConfirm ? "is-valid" : "is-invalid";
    },

    passwordConfirmValidationClass() {
      if (!this.form.passwordConfirm && !this.form.password) return "";
      return this.form.password === this.form.passwordConfirm ? "is-valid" : "is-invalid";
    },
  },

  methods: {
    async loadQueues() {
      try {
        const response = await axios.get("/listQueueProfile");
        const data = response.data;

        if (Array.isArray(data)) {
          this.queues = data;
        } else if (data && typeof data === "object" && Array.isArray(data.queues)) {
          this.queues = data.queues;
        } else {
          this.queues = [];
          console.warn("Formato inesperado das filas.");
        }
      } catch (error) {
        console.error("Erro ao carregar filas:", error);
        this.queues = [];
      }
    },

    normalizeQueues(value) {
      let queues = value || [];

      if (typeof queues === "string") {
        try {
          queues = JSON.parse(queues);
        } catch (e) {
          queues = [];
        }
      }

      if (!Array.isArray(queues)) {
        queues = [];
      }

      return queues.map((item) => {
      if (item && typeof item === "object") {
        if (item.id !== undefined) return item.id;
        if (item.value !== undefined) return item.value;
        if (item.queue !== undefined) return item.queue;
      }

      return item;
      });
    },

    updateQueue(value) {
      this.form.queue = this.normalizeQueues(value);
    },

    async open() {
      this.clearMessages();
      this.loading = false;
      this.previewPhoto = null;
      this.form.password = "";
      this.form.passwordConfirm = "";
      this.form.photoFile = null;

      await this.loadQueues();

      try {
        const response = await axios.get("listUserProfile");
        const payload = response.data;
        const users = Array.isArray(payload)
          ? payload
          : Array.isArray(payload && payload.data)
          ? payload.data
          : [];

        const userId = user.getId();
        const foundUser = users.find((u) => String(u.id) === String(userId));

        if (!foundUser) {
          this.errorMessage = "Usuário autenticado não encontrado.";
          return;
        }

        this.form.name = foundUser.name || "";
        this.form.email = foundUser.email || "";
        this.form.extension = foundUser.extension_line || "";
        this.form.login = foundUser.login || "";
        this.form.photoUrl = foundUser.photo ? `/storage/${foundUser.photo}` : "";

        this.form.queue = this.normalizeQueues(foundUser.queue);

        this.visible = true;

        await this.$nextTick();

        this.queueComponentKey += 1;
      } catch (error) {
        console.error("Erro ao abrir modal:", error);
        this.errorMessage = "Erro ao carregar dados do usuário.";
      }
    },

    close() {
      this.visible = false;
    },

    onPhotoChange(event) {
      const file = event.target.files[0];
      if (!file) return;

      if (!file.type.startsWith("image/")) {
        this.errorMessage = "Por favor, selecione um arquivo de imagem válido.";
        return;
      }

      this.form.photoFile = file;
      this.errorMessage = "";

      const reader = new FileReader();
      reader.onload = (e) => {
        this.previewPhoto = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    async saveProfile() {
      this.clearMessages();

      if (this.form.password !== this.form.passwordConfirm) {
        this.errorMessage = "A senha e a confirmação não conferem.";
        return;
      }

      this.loading = true;

      try {
        const formData = new FormData();

        if (this.form.name) formData.append("name", this.form.name);
        if (this.form.email) formData.append("email", this.form.email);
        if (this.form.extension) formData.append("extension_line", this.form.extension);
        if (this.form.login) formData.append("login", this.form.login);

        formData.append("queue", JSON.stringify(this.normalizeQueues(this.form.queue)));

        if (this.form.password) {
          formData.append("password", this.form.password);
          formData.append("password_confirmation", this.form.passwordConfirm);
        }

        if (this.form.photoFile) {
          formData.append("photo", this.form.photoFile);
        }

        const csrfToken = document
          .querySelector('meta[name="csrf-token"]')
          .getAttribute("content");

        await axios.post("/update-profile", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "X-CSRF-TOKEN": csrfToken,
          },
        });

        this.successMessage = "Perfil atualizado com sucesso!";
        this.loading = false;

        setTimeout(() => {
          this.close();
          location.reload();
        }, 1000);
      } catch (error) {
        this.loading = false;

        if (error.response && error.response.status === 422) {
          this.errorMessage =
            Object.values(error.response.data.errors).flat()[0] || "Erro de validação.";
        } else {
          this.errorMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            "Erro ao salvar perfil. Tente novamente.";
        }
      }
    },

    clearMessages() {
      this.errorMessage = "";
      this.successMessage = "";
    },
  },
};
</script>

<style scoped>
.modal-backdrop {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1050;
}

.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1060;
  border-radius: 0.3rem;
  box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
  overflow-y: auto;
}

.modal-content {
  background: #fff;
  border-radius: 0.3rem;
}

.close {
  font-size: 1.5rem;
  font-weight: 700;
  color: #000;
  background: transparent;
  border: none;
  opacity: 0.5;
}

.close:hover {
  opacity: 0.75;
  cursor: pointer;
}

.input-group-text {
  background-color: #0f6b72;
  color: #fff;
  border: none;
  min-width: 42px;
  display: flex;
  justify-content: center;
}

img.rounded-circle {
  object-fit: cover;
}
</style>